import React, { useEffect, useState } from "react";
import "./scratchScript.scss";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import uploadIcon from "../../../assets/icons/upload.svg";
import { flask_url, node_url } from "../../../Socket";
import { toast } from "react-toastify";
import { concrete_restoration, dock_and_deck, painting, pavers_landscaping, pool_renovation, roofing, seawalls, stucco_repair, waterproofing } from "../../../constants";
import axios from "axios";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import WholeLoader from "../../WholeLoader";
import SmallLoader from "../SmallLoader";
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
export let agentName =""
const ScratchScript = ({ agentData, agentPromptType, userId , type }) => {
  var authToken = JSON.parse(localStorage.getItem("bearerToken"));
 console.log("type, authToken",type);
  const [scriptData, setScriptData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [thumbnailUrl, setThumbnailUrl] = useState("");
  const [aiGenerated, setAiGenerated] = useState();
  const [fileGenerated, setFileGenerated] = useState();
  const [fileModal, setFileModal] = useState(false);
  const [voiceId, setVoiceId] = useState(1);
  const [checkNumber, setCheckNumber] = useState(false);
  const [userName, setUserName] = useState("");
  const [showLoader, setLoader] = useState(false);

  useEffect(() => {
    if (agentPromptType == "Stucco Repair") {
      setScriptData(stucco_repair(agentData.agentName));
    } else if (agentPromptType == "Concrete Restoration") {
      setScriptData(concrete_restoration(agentData.agentName));
    } else if (agentPromptType == "Painting") {
      setScriptData(painting(agentData.agentName));
    } else if (agentPromptType == "Roofing") {
      setScriptData(roofing(agentData.agentName));
    } else if (agentPromptType == "Waterproofing") {
      setScriptData(waterproofing(agentData.agentName));
    } else if (agentPromptType == "Pool Renovation & Restoration") {
      setScriptData(pool_renovation(agentData.agentName));
    } else if (agentPromptType == "Pavers and Landscaping") {
      setScriptData(pavers_landscaping(agentData.agentName));
    } else if (agentPromptType == "Dock & Deck") {
      setScriptData(dock_and_deck(agentData.agentName));
    } else if (agentPromptType == "Seawalls") {
      setScriptData(seawalls(agentData.agentName));
    }
    // console.log("type"+scriptData);
  }, [agentPromptType]);

  const [selectedOption, setSelectedOption] = useState("male");
  const [selectedAction, setSelectedAction] = useState(null);

  const [show, setShow] = useState(false);
  const [showSaveAction, setShowSaveAction] = useState(false);
  const [showmodal3, setShowmodal3] = useState(true);
  const [showmodal4, setShowmodal4] = useState(false);
  const [showmodalCall, setShowmodalCall] = useState(false);
  const [showmodalTracking, setShowmodalTracking] = useState(false);
  const [showmodalTransferCall, setShowmodalTransferCall] = useState(false);
  const [showmodalSendMail, setShowmodalSendMail] = useState(false);
  const [showmodalBookAppoint, setShowmodalBookAppoint] = useState(false);
  const [transferCall, setTransferCall] = useState("")
  const handleShowmodal3 = () => setShowmodal3(true);
  const handleShowmodal4 = () => {
    setShowmodal4(true);
  };
  const handleShowmodalCall = () => setShowmodalCall(true);
  const handleShowmodalTracking = () => setShowmodalTracking(true);
  const handleShowmodalTransferCall = () => {
    setShowmodalTransferCall(true);
    setShow(false);
  };
  const handleShowmodalSendMail = () => {
    setShowmodalSendMail(true);
    setShow(false);
  };
  const handleShowmodalBookAppoint = () => {
    setShowmodalBookAppoint(true);
    setShow(false);
  };

  const handleClose3 = () => setShowmodal3(false);
  const handleClose4 = () => setShowmodal4(false);
  const handleCloseCall = () => setShowmodalCall(false);
  const handleCloseTracking = () => setShowmodalTracking(false);
  const handleCloseTransferCall = () => setShowmodalTransferCall(false);
  const handleCloseSendMail = () => setShowmodalSendMail(false);
  const handleCloseBookAppoint = () => setShowmodalBookAppoint(false);

  const [number, setNumber] = useState(null);

  const handleShow = () => {
    setShow(true);
  };

  const handleShowSaveAction = () => {
    // CallAgent();
    setShow(false);
  };



  useEffect(()=>{
    if(type === "2")
      {
        setShowmodal3(false);
        setShowmodal4(false);
        setShowmodalCall(false);
        setShowmodalTracking(false);
        setShowmodalTransferCall(false);
        setShowmodalSendMail(false);
        setShowmodalBookAppoint(false);
      }
  },[type])
  // const handleShowSaveAction1 = () => {
  //   CallAgent();
  // };
  const [userNameSaveAction, setUserNameSaveAction] = useState("");
  const handleShowSaveAction1 = () => {
    // setUserName
    if (userName === "") {
      toast.error("Please fill out all fields.");
      return;
    } else {
      CallAgent();
    }
  };

  const handleClose = () => {
    setShow(false);
  };

  // const handleClose1 = () => {
  //   setShowSaveAction(false);
  // };

  const handleDivClick = (actionType) => {
    setSelectedAction(actionType);
  };

  function stringToArray(inputString) {
    return inputString.split("\n").filter(Boolean);
  }

  const handleRadioChange = (value) => {
    setSelectedOption(value);
    value === "male" ? setVoiceId(1) : setVoiceId(2);
  };

  const navigate = useNavigate();

  const updateText = (index, newText) => {
    console.log("updateText", updateText);
    console.log("index", index);

    const updatedScriptResponse = [...scriptData];

    updatedScriptResponse[index] = newText;

    // setScriptData(updatedScriptResponse);
  };

  const Logout = () => {
    try {
      localStorage.removeItem("bearerToken");
      localStorage.removeItem("userId");
      localStorage.removeItem("phone");
      localStorage.removeItem("name");
      navigate("/");
    } catch (error) {
      console.log(error);
    }
  };

  const CallAgentAction = () =>{
    if(!transferCall) return toast.error("enter your transfer call here")
    fetch(`${node_url}/customer/updateAgent/${agentData?._id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify({
        transfer_call_number: transferCall
      }),
    })
      .then((response) => {
        if (!response.ok) {
          setShowmodalCall(false);
          throw new Error("Network response was not ok");
        }
        setShowmodalCall(false);
   
        return response.json();
      })
      .then((data) => {
        console.log(" :", data);
        toast.success("transfer call successfully added");
      })
      .catch((error) => {
        toast.error("Opps Something Went Wrong try again later");
        console.log("error", error);
      });
  }


  const CallAgent = () => {
    fetch(`${flask_url}/outboundcall_customAgent`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        number: `${number}`,
        agent_id: agentData._id,
        voice_id: `${voiceId}`,
        userName: userName,
        scriptData: scriptData.join("\n\n*Wait for the Prospect to Respond*\n\n"),
        transfer_call_number:transferCall
      }),
    })
      .then((response) => {
        if (!response.ok) {
          setShowmodalCall(false);
          throw new Error("Network response was not ok");
        }
        setShowmodalCall(false);
        setNumber("")
        setUserName("")
        return response.json();
      })
      .then((data) => {
        console.log(" :", data);
        toast.success("Call Started");
      })
      .catch((error) => {
        toast.error("Opps Something Went Wrong try again later");
        console.log("error", error);
      });
  };

  const UpdateScript = () => {
    if(!scriptData) return toast.error("Not updated script");
    fetch(`${node_url}/customer/update-script/${agentData?._id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify({
        script: scriptData,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        return response.json();
      })
      .then((data) => {
        console.log(" :", data);
        toast.success("Script Saved");
      })
      .catch((error) => {
        toast.error("Opps Something Went Wrong try again later");
        console.log("error", error);
      });
  };

  const handleUploadResponse = async (url, fileType) => {
    try {
      setLoader(true);
      setLoading(true);
      let data = {
        file: url,
        fileType: fileType,
      };
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        // url: `${process.env.REACT_APP_API_URL}/customer/transcribe/${userId}`,
        url: `http://localhost:8000/customer/transcribe/${userId}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        data: data,
      };
      axios
        .request(config)
        .then((response) => {
          console.log("inside functtion", url);
          // console.log(JSON.stringify(response?.data));

          //display back prompt
          if (response.data) {
            const GeneratedResponse = response?.data?.formatedRes;
            // console.log("Responce From Gpt :", GeneratedResponse);

            setScriptData(GeneratedResponse);

            // let formatedRes = stringToArray(GeneratedResponse);
            // setScriptData(formatedRes);

            setFileGenerated(GeneratedResponse);
            setFileModal(false);
            setLoading(false);
            setLoader(false);
            handleClose3();
            handleClose4();
          }
        })
        .catch((error) => {
          setLoader(false);
          console.log("Here");
          setLoading(false);
          console.log(error);
        });
    } catch (err) {
      setLoader(false);
      setLoading(false);
      console.log(err);
    }
  };

  const handleFileChange = (event) => {
    const File = event.target.files[0];
    // console.log(File);
    const fileFolderPath = "Document";
    console.log("file: ", File);
    if (File) {
      UploadFileToS3(File, fileFolderPath)
        .then((result) => {
          console.log("Upload successful:", result);
          handleUploadResponse(result.file_url, File.type);
        })
        .catch((error) => {
          console.error("Upload failed:", error);
        });
    } else {
      console.error("No file selected.");
    }
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result);
      };
    });
  };

  const UploadFileToS3 = async (file, fileFolderPath) => {
    const convertedFile = await convertToBase64(file);
    console.log(fileFolderPath);
    return new Promise(async (resolve, reject) => {
      try {
        //Url set in the server. Server will return s3 object download url
        let url = `${process.env.REACT_APP_API_URL}/customer/aws-Fileupload`;
        // let url = `http://localhost:8000/customer/aws-Fileupload`;
        // setLoading(true);
        axios
          .post(
            url,
            {
              file: convertedFile,
              fileFolderPath: fileFolderPath,
              fileName: file.name,
              fileType: file.type,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
            }
          )
          .then((response) => {
            console.log("response", response);
            if (response.data.success == true) {
              console.log("response.data.thumbnail_url", response.data.file_url);
              if (response.data.file_url) {
                const myUrl = response.data.file_url;
                // console.log(" url", myUrl);
              }
              resolve({
                success: true,
                file_url: response.data.file_url,
              });
            } else {
              reject({ success: false, error: response.data.error });
            }
          })
          .catch((err) => {
            console.log(err);
            reject({ success: false, error: err });
          });
      } catch (error) {
        console.log(error);
        reject({ success: false, error });
      }
    });
  };

  const handleInputChange = (value) => {
    console.log("Number :", value);

    setNumber(value);
    if (value && isValidPhoneNumber(value.toString()) != false) {
      setCheckNumber(true);
    } else {
      setCheckNumber(false);
    }
  };

  const getAgentById = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/prompts`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.log(data);
    } catch (error) {
      console.error("Error fetching agent:", error);
    }
  };

  // console.log("Check Number", checkNumber);

  // console.log("agent Data :", agentData);
  // console.log("agent Data ._id:", agentData._id);

  // console.log("file Generated Data :", fileGenerated);
  // console.log("agent Prompt Type :", agentPromptType);
  // console.log("userId :", userId);
  // console.log("script Data :", scriptData);
  // console.log("number :", number);
  // console.log("voiceId :", voiceId);


  const handleTransferCall = (event) =>{
    setTransferCall(event.target.value)
  }


  return (
    <div className="scratchScriptWrapper">
      <div className="scratchTopMenu">
        <div className="leftMenu">
          <h5>Group Landev</h5>
          <h6>Standard Editor (Edit you script from scratch) </h6>
        </div>

        <div className="rightMenu">
          <div className="login-btn" onClick={Logout}>
            <button>Logout</button>
          </div>

          <p className="needHelp">Need Help?</p>
        </div>
      </div>

      <div>
        <button className="themebtn-1 mt-5" onClick={UpdateScript}>
          Save
        </button>
      </div>

      <div className="scratchMainDiv-container">
        <div className="scratchMainDiv">
          {scriptData && scriptData.length > 0 ? (
            scriptData.map((item, index) => {
              return (
                <>
                  <h6 className="grayText">*Wait for the Prospect to Respond*</h6>
                  <p
                    className="gptcontent"
                    style={{ color: "black", 
                    wordWrap: "break-word" ,
                    
                      whiteSpace: 'nowrap',
                      flex: 'none',
                      margin: '0 10px',
                      minWidth: '200px',
                      maxWidth: '300px',
                    
                    }}
                    contentEditable={true}
                    onChange={(e) => updateText(index, e.target.innerText)}
                    suppressContentEditableWarning={true}
                  >
                    {item}
                  </p>
                </>
              );
            })
          ) : (
            <></>
          )}
          {/* <button className="generateScriptBtn my-4"> Generate Script</button> */}
          </div>



          
        <div className="scratchMainDiv-rightOpt-container">
          <div className="">
           {
              /* <div className="scratchMainDiv-rightOpt-box d-flex justify-content-between align-items-center">
               <Icon icon="ph:link" className="link-icon-script" />
              <select class="selectpicker">
                <option>Connect a Knowledge Base</option>
                <option>Delta</option>
                <option>Beta</option>
              </select>
           </div>*/}

            <div className="scratchMainDiv-rightOpt-box d-flex justify-content-start align-items-center mt-3" onClick={handleShow}>
              <Icon icon="ant-design:thunderbolt-outlined" className="link-icon-script" />
              <p className="pl-2">Add An Action</p>
            </div>

         {  /* <div className="scratchMainDiv-rightOpt-box d-flex justify-content-start align-items-center mt-3" onClick={handleShowmodal3}>
              <Icon icon="ph:note-duotone" className="link-icon-script" />
              <p className="pl-2">Magically Generate Script Using AI</p>
          </div>*/}

            <div className="scratchMainDiv-rightOpt-box d-flex jus mt-3">
              <Icon icon="ph:note-duotone" className="link-icon-script mr-2" />
              <div className="radio">
                <label>
                  Male
                  <input type="radio" value="male" className="ml-1 mr-2" checked={selectedOption === "male"} onChange={() => handleRadioChange("male")} />
                </label>
              </div>

              <div className="radio">
                <label>
                  Female
                  <input type="radio" value="female" className="ml-1 mr-2" checked={selectedOption === "female"} onChange={() => handleRadioChange("female")} />
                </label>
              </div>
            </div>

            <div className="scratchMainDiv-rightOpt-box d-flex justify-content-start align-items-center mt-3">
              <Icon icon="solar:notes-line-duotone" className="link-icon-script" />
              <p className="pl-2">Post Call Notes</p>
            </div>

            {/* <div className="scratchMainDiv-rightOpt-box d-flex justify-content-start align-items-center mt-3" onClick={handleShowmodalTracking}> */}
            <div className="scratchMainDiv-rightOpt-box d-flex justify-content-start align-items-center mt-3">
              <Icon icon="tabler:track" className="link-icon-script" />
              <p className="pl-2">Setup Stats Tracking</p>
            </div>
          </div>

          <button className="script-btn" onClick={handleShowmodalCall}>
            Talk To Your Agent
          </button>
        </div>
      </div>

      {/* Modals Add A Action */}
      <Modal show={show} onHide={handleClose} className="agentModal">
        <Modal.Header closeButton>
          <Modal.Title className="">What Action Do You Want Your Agent To Take?</Modal.Title>
        </Modal.Header>

        <Modal.Body className="modalBody">
          <div className="border">
            <div className={`sss actionTypeDiv ${selectedAction === "action1" ? "selected" : ""}`} onClick={() => handleDivClick("action1")}>
              <label className="labelssss" htmlFor="action1" onClick={handleShowmodalTransferCall}>
                <input className="book-input" type="radio" name="actionType" id="action1" checked={selectedAction === "action1"} onChange={() => {}} />
                <div>
                  <h5>Transfer Call</h5>
                  <p>
                    If you want your agent to book an appointment, select this option. You'll be able to connect a calendar with your GroupLanaccount for your agent to book
                    appointments to.
                  </p>
                </div>
              </label>
            </div>

            {/*
            <div className={`actionTypeDiv ${selectedAction === "action2" ? "selected" : ""}`} onClick={() => handleDivClick("action2")}>
              <label className="labelssss" htmlFor="action2" onClick={handleShowmodalSendMail}>
                <input className="book-input" type="radio" name="actionType" id="action2" checked={selectedAction === "action2"} onChange={() => {}} />
                <div>
                  <h5>Send Mail</h5>
                  <p>
                    If you want your agent to book an appointment, select this option. You'll be able to connect a calendar with your GroupLanaccount for your agent to book
                    appointments to.
                  </p>
          </div>
          </label>
          </div>
        */}

            <div className={`actionTypeDiv ${selectedAction === "action3" ? "selected" : ""}`} onClick={() => handleDivClick("action3")}>
              <label className="labelssss" htmlFor="action3" onClick={handleShowmodalBookAppoint}>
                <input className="book-input" type="radio" name="actionType" id="action3" checked={selectedAction === "action3"} onChange={() => {}} />
                <div>
                  <h5>Book appointment</h5>
                  <p>
                    If you want your agent to book an appointment, select this option. You'll be able to connect a calendar with your GroupLanaccount for your agent to book
                    appointments to.
                  </p>
                </div>
              </label>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button className="save-btn" onClick={handleShowSaveAction}>
            Use Selected Action Type
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Modals Add A Action */}

      {/* Modals Save Action */}
      {/* <Modal show={showSaveAction} onHide={handleClose1} className="agentModal">
        <Modal.Header closeButton>
          <Modal.Title className="">Save Your Changes</Modal.Title>
        </Modal.Header>

        <Modal.Body className="modalBody text-center">Woohoo, you are reading this text in a modal!</Modal.Body>

        <Modal.Footer>
          <Button className="save-btn" onClick={handleClose1}>
            save changes
          </Button>
        </Modal.Footer>
      </Modal> */}
      {/* Modals Save Action */}

      {/* Magically Generating Script Code */}
      <Modal
        show={showmodal3}
        onHide={() => {
          handleClose3();
        }}
        className="agentModal3"
      >
        <Modal.Header closeButton></Modal.Header>

        <Modal.Body className="modalBody">
          <h4>How do you want to magically generate a script?</h4>
          <div className="magicalGeneratingMainBox">
            <div
              onClick={() => {
                console.log("i am recording")
                handleClose3();
                handleShowmodal4();
              }}
              className="callRecordingDiv"
            >
              <h5>Upload a call recording </h5>
              <p>Clone your best rep by uploading a call recording.</p>
            </div>

      

           
          </div>
        </Modal.Body>
        <Modal.Footer>
          {
            /*<Button
            onClick={() => {
              handleClose3();
            }}
            className="script-btn"
          >
            Select Magic Generation Type
          </Button>*/
        }
        </Modal.Footer>
      </Modal>
      {/* Magically Generating Script Code */}

      {/*Upload Your Call Code */}
      <Modal
        show={showmodal4}
        onHide={() => {
          if (!showLoader) {
            handleClose4();
          }
        }}
        className="agentModal4"
      >
        <Modal.Header closeButton onClick={handleClose4}></Modal.Header>
        <Modal.Body className="modalBody">
          <h4>Upload a Call Recording</h4>
          <p className="callRpara">
            Clone your best rep by uploading a call recording from them and we'll magically create a script for your Group Land av Agent to follow based on it.
          </p>
          <section id="form-file-upload">
            {!showLoader ? (
              <>
                <input type="file" id="input-file-upload" onChange={handleFileChange} />
                {/* <input type="file" id="input-file-upload" /> */}
                <label id="label-file-upload" htmlFor="input-file-upload">
                  <div>
                    <img className="mb-3" src={uploadIcon} alt="" />
                    <p className="upload-text">Click to upload files from computer</p>
                    <p className="upload-text2">or drag and drop here</p>
                  </div>
                </label>
              </>
            ) : (
              <SmallLoader />
            )}
          </section>
        </Modal.Body>
      </Modal>
      {/*Upload Your Call Code */}

      {/* Modals Call */}
      <Modal show={showmodalCall} onHide={handleCloseCall} className="agentModal">
        <Modal.Header closeButton>
          <Modal.Title className="">Talk To Your Agent</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBody">
          <p className="text-center">
            Once you press "Call" below, you'll join the queue to receive a call from your agent. When you reach first in line, GroupLan will call you at the number you enter
            below.
          </p>

          <div className="agentCall-innerDiv">
            <div>
              <h5>What name should GroupLanDev call you?</h5>
              <input type="text" placeholder="Enter yout name" className="mt-1" onChange={(e) => setUserName(e.target.value)} />
              {/* <input type="text" placeholder="Enter your name" className="mt-1" onChange={(e) => { setUserName(e.target.value); validateInputs(); }} /> */}
            </div>
            <div className="pt-2">
              <h5>What phone number do you want GroupLanDev to call?</h5>
              <PhoneInput international countryCallingCodeEditable={false} defaultCountry="CA" value={number} onChange={(value) => handleInputChange(value)} autoComplete="off" />
              {/* <input type="number" placeholder="Enter phone number" className="mt-1" onChange={(e) => setNumber(e.target.value)} /> */}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button className="save-btn" disabled={!checkNumber} onClick={handleShowSaveAction1}>
            Call
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Modals Call */}

      {/* Modals Call */}
      <Modal show={showmodalTracking} onHide={handleCloseTracking} className="agentModal">
        <Modal.Header closeButton>
          <Modal.Title className="">What’s the desired outcome you want your agent to accomplish on this call?</Modal.Title>
        </Modal.Header>
        <p className="text-center">We are going to set up tracking for it:</p>
        <Modal.Body className="modalBody">
          <div className="scratchMainDiv-track-box d-flex justify-content-between align-items-center">
            <label>Desired Outcome:</label>
            <select class="selectpickerNew">
              <option>Booked Appointment</option>
              <option>Custom</option>
            </select>
          </div>
          <div className="howtoTrack-div">
            <h5>How do you want to track if this outcome is accomplished?</h5>
            <h6>Automatic tracking (No setup, highly accurate)</h6>
            <p>Tracks by listening to each call recording</p>
          </div>
          <div className="howtoTrack-div">
            <h6>Verified tracking (advanced setup, almost 100% accurate)</h6>
            <p>Tracks using webhooks/api</p>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button className="save-btn" onClick={handleShowmodalTracking}>
            Call
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Modals Call */}

      {/* Modals Tranfer Call */}
      <Modal show={showmodalTransferCall} onHide={handleCloseTransferCall} className="agentModal">
        <Modal.Header closeButton>
          <Modal.Title className="">Enter the Transfer call number</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBody">
          <label>Transfer Call Number</label>
          <input type="number" alt="" value={transferCall} onChange={handleTransferCall} />
        </Modal.Body>
        
          <Modal.Footer>
          <Button className="save-btn" on onClick={()=> CallAgentAction()}>save</Button>
         </Modal.Footer>
      
      </Modal>
      {/* Modals Tranfer Call */}

      {/* Modals Tranfer Call */}
      <Modal show={showmodalSendMail} onHide={handleCloseSendMail} className="agentModal">
        <Modal.Header closeButton>
          <Modal.Title className="">Enter Email Information</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBody">
          <label>Email:</label>
          <input type="email" alt="" />
          <label>Description</label>
          <input type="text" alt="" />
          {/* <input type="number" alt="" /> */}
          <label>Email Subject</label>
          <input type="text" alt="" />
        </Modal.Body>

        <Modal.Footer>
          <Button className="save-btn">Call</Button>
        </Modal.Footer>
      </Modal>
      {/* Modals Tranfer Call */}

      {/* Modals Tranfer Call */}
      <Modal show={showmodalBookAppoint} onHide={handleCloseBookAppoint} className="agentModal">
        <Modal.Header closeButton>
          <Modal.Title className="">Enter Email Information</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBody">
          <label>Calander Availability</label>
          <input type="text" alt="" />
          <label>Event Type ID</label>
          <input type="text" alt="" />
          {/* <input type="number" alt="" /> */}
          <label>Event Booking Title</label>
          <input type="text" alt="" />
          <label>Event Booking Description</label>
          <input type="text" alt="" />
          <label>Call Api Key</label>
          <input type="text" alt="" />
        </Modal.Body>

        <Modal.Footer>
          <Button className="save-btn">Call</Button>
        </Modal.Footer>
      </Modal>
      {/* Modals Tranfer Call */}
    </div>
  );
};

export default ScratchScript;
